import api from "@/api";

export default {
    state: {
        notes: [],
        noteFiles: [],
        noteFilesId: null,
    },
    getters: {
        notes: (state) => state.notes,
        noteFiles: (state) => state.noteFiles,
        noteFilesId: (state) => state.noteFilesId,
    },
    mutations: {
        setNotes: (state, data) => { state.notes = data; },
        setNoteFiles: (state, data) => { state.noteFiles = data; },
        setNoteFilesId: (state, data) => { state.noteFilesId = data; },
    },
    actions: { 
        showToast({ commit }, { type, message }) {
            commit("setToast", {
                display: true,
                type: type,
                message: message,
            }, { root: true });  
        },

        getNotes: async ({ commit, dispatch }, id) => {
            try {
                const response = await api({ requiresAuth: true }).get(`v1/customer-notes/${id}`);
                const { data } = response.data;
                commit("setNotes", data);
                return data;
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || "Failed to load notes." 
                });
                throw error;
            }
        },

        createNotes: async ({ dispatch }, payload) => {
            try {
                const response = await api({ requiresAuth: true }).post("v1/notes", payload);
                await dispatch("getNotes", payload.customer_id);
                
                dispatch("showToast", { 
                    type: "success", 
                    message: response.data.message || "Note created successfully!" 
                });
                return response.data.data.id;
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || "Could not create note." 
                });
                throw error;
            }
        },

        deleteNotes: async ({ dispatch }, { noteId, customerId }) => {
            try {
                const response = await api({ requiresAuth: true }).delete(`v1/notes/${noteId}`);
                await dispatch("getNotes", customerId);
                
                dispatch("showToast", { 
                    type: "success", 
                    message: response.data.message || "Note deleted." 
                });
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || "Failed to delete note." 
                });
                throw error;
            }
        },

        updateNotes: async ({ dispatch }, payload) => {
            try {
                const response = await api({ requiresAuth: true }).patch(`v1/notes/${payload.id}`, payload);
                await dispatch("getNotes", payload.customer_id);
                
                dispatch("showToast", { 
                    type: "success", 
                    message: response.data.message || "Note updated successfully." 
                });
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || "Update failed." 
                });
                throw error;
            }
        },

        addNotesFile: async ({ dispatch }, { noteId, files }) => {
            try {
                const formData = new FormData();
                files.forEach(file => formData.append("note_files[]", file));
                
                const response = await api({ requiresAuth: true }).post(
                    `v1/notes/${noteId}/files`, 
                    formData, 
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                dispatch("showToast", { 
                    type: "success", 
                    message: response.data.message || "Files uploaded successfully." 
                });
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || "File upload failed." 
                });
                throw error;
            }
        },

        fetchNoteFiles: async ({ commit, dispatch }, noteId) => {
            try {
                const response = await api({ requiresAuth: true }).get(`/v1/notes/${noteId}`);
                const { data } = response.data; 
                commit("setFilesToEdit", data.files, { root: true });
                return data;
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || "Could not retrieve files." 
                });
                throw error;
            }
        },

        markNoteAsComplete: async ({ dispatch }, { noteId }) => {
            try {
                const response = await api({ requiresAuth: true }).patch(`v1/notes/${noteId}/mark-done`);
                
                dispatch("showToast", { 
                    type: "success", 
                    message: response.data.message || "Task completed!" 
                });
            } catch (error) {
                dispatch("showToast", { 
                    type: "error", 
                    message: error.response?.data?.message || "Failed to complete task." 
                });
                throw error;
            }
        }
    },
}